import { NavLink, useLocation } from "react-router-dom";
import styles from "./Sidebar.module.css";

const SidebarNavItem = ({ item, isCollapsed, onNavigate, isSubItem = false }) => {
  const location = useLocation();
  const Icon = item.icon;

  const isItemActive = () => {
    if (!item.path) return false;
    const currentFull = (location.pathname + location.search).toLowerCase();
    const itemPath = item.path.toLowerCase();

    // If item.path has query parameters (e.g., ?type=RESIDENTIAL)
    if (itemPath.includes("?")) {
      return itemPath === currentFull;
    }

    // If item.path is base path (e.g., /properties or /users)
    if (itemPath === location.pathname.toLowerCase()) {
      return !location.search || location.search === "";
    }

    return false;
  };

  const active = isItemActive();

  if (item.isExternal) {
    return (
      <a
        href={item.path}
        target="_blank"
        rel="noopener noreferrer"
        className={`${styles.navItem} ${isCollapsed ? styles.navItemCollapsed : ""} ${
          isSubItem ? styles.subItem : ""
        }`}
        title={isCollapsed ? item.label : undefined}
      >
        {Icon && <Icon className={styles.itemIcon} />}
        {!Icon && isSubItem && <span className={styles.subItemBullet} />}
        {!isCollapsed && (
          <>
            <span className={styles.itemLabel}>{item.label}</span>
            <span className={styles.externalBadge}>Launch</span>
          </>
        )}
      </a>
    );
  }

  return (
    <NavLink
      to={item.path}
      onClick={onNavigate}
      className={`${styles.navItem} ${active ? styles.navItemActive : ""} ${
        isCollapsed ? styles.navItemCollapsed : ""
      } ${isSubItem ? styles.subItem : ""}`}
      title={isCollapsed ? item.label : undefined}
    >
      {Icon && <Icon className={styles.itemIcon} />}
      {!Icon && isSubItem && <span className={styles.subItemBullet} />}
      {!isCollapsed && <span className={styles.itemLabel}>{item.label}</span>}
    </NavLink>
  );
};

export default SidebarNavItem;
